import { loadFontsByName } from "./fontLoaders.js";

const preloadPromisesByKey = new Map();

function normalizeFontNames(fontNames) {
    return [...new Set((fontNames || []).filter(Boolean))].sort();
}

export function preloadFontsByName(fontNames) {
    const fonts = normalizeFontNames(fontNames);

    if (!fonts.length) {
        return Promise.resolve();
    }

    const cacheKey = fonts.join("|");
    if (!preloadPromisesByKey.has(cacheKey)) {
        const preloadPromise = loadFontsByName(fonts).catch((error) => {
            console.warn("Failed to preload fonts", fonts, error);
        });

        preloadPromisesByKey.set(cacheKey, preloadPromise);
    }

    return preloadPromisesByKey.get(cacheKey);
}

export function preloadFontPair(fontPair) {
    return preloadFontsByName([fontPair?.headline, fontPair?.text]);
}

export function preloadFontPairs(fontPairs) {
    return preloadFontsByName((fontPairs || []).flatMap(fontPair => [fontPair?.headline, fontPair?.text]));
}
